import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Title from "./title";
import { ComonIcons } from "../contents/commonIcons";
import DataTable from "react-data-table-component";
import moment from "moment";
import { setExpiringTodayPopupOpen } from "../redux/actions/gym/gymAction";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import { getExpiringToday } from "../redux/actions/api/apiAction";

export const ExpiringTodayPopUp = () => {
  const { expiringTodayPopupOpen, expiringTodayMemberships } = useSelector(
    (state) => state.gym
  );
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(setExpiringTodayPopupOpen(!expiringTodayPopupOpen));
  };


  const tableColumns = [
    {
      name: `Member`,
      selector: (row) => (
        <Link
          exact
          to={`/gym-panel/membersinfo/${row.memberId}`}
          onClick={toggle}
        >
          {row.memberName}
        </Link>
      ),
    },
    {
      name: `Email`,
      selector: (row) => `${row.email}`,
    },
    {
      name: `Phone`,
      selector: (row) => `${row.phone}`,
    },
    {
      name: `Package`,
      selector: (row) => row.name,
    },
    {
      name: `Started`,
      selector: (row) => `${moment(row.startDate).format("DD-MM-YYYY")}`,
    },
  ];

  return (
    <Modal
      isOpen={expiringTodayPopupOpen}
      centered={true}
      size={"lg"}
      className="large-pop adding-popup"
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Expiring Today" />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12}>
              <h3 className="text-danger text-center text-wrap">
                Expiring Today
              </h3>
              {!expiringTodayMemberships && <ClipLoader />}
              {expiringTodayMemberships && (
                <div className="table-section">
                  <div className="table-main-block">
                    <DataTable
                      columns={tableColumns}
                      data={expiringTodayMemberships}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};
